_getProfiles